export const HELP_ARTICLE_UI_COPY_BN = {
  "onThisPage": "এই পৃষ্ঠায়",
  "jumpMessage": "এক্সপোর্ট করার আগে আপনাকে যে সঠিক ওয়ার্কফ্লো প্রশ্নটির উত্তর দিতে হবে সেখানে যান।",
  "faq": "FAQ",
  "by": "দ্বারা",
  "lastReviewed": "সর্বশেষ পর্যালোচনা করা হয়েছে"
};

export const COOKIE_CONSENT_COPY_BN = {
  "text": "আমরা প্রয়োজনীয় কার্যকারিতা, বিশ্লেষণ এবং বিজ্ঞাপন পরিমাপের জন্য কুকি এবং অনুরূপ প্রযুক্তি ব্যবহার করি (গুগল এবং মেটা)।",
  "detail": "আপনি প্রত্যাখ্যান করলে, ঐচ্ছিক বিশ্লেষণ এবং বিজ্ঞাপন পরিমাপ বন্ধ থাকবে। আমাদের গোপনীয়তা বিজ্ঞপ্তিতে আরও জানুন।",
  "manage": "কুকি সেটিংস",
  "save": "পছন্দগুলি সংরক্ষণ করুন",
  "essentialTitle": "অপরিহার্য কুকিজ",
  "essentialDesc": "নিরাপত্তা, লগইন, এবং মূল সাইট কার্যকারিতার জন্য প্রয়োজনীয়।",
  "analyticsTitle": "বিশ্লেষণ কুকিজ",
  "analyticsDesc": "ট্রাফিক এবং পণ্যের ব্যবহার বুঝতে আমাদের সাহায্য করুন (উদাহরণস্বরূপ Google Analytics)।",
  "advertisingTitle": "বিজ্ঞাপন পরিমাপ",
  "advertisingDesc": "বিজ্ঞাপনের কার্যক্ষমতা এবং রূপান্তর পরিমাপ করুন (উদাহরণস্বরূপ Meta Pixel/CAPI)।",
  "gpcNotice": "আপনার ব্রাউজারে বিশ্বব্যাপী গোপনীয়তা নিয়ন্ত্রণ সক্ষম করা হয়েছে, তাই বিজ্ঞাপন পরিমাপ বন্ধ থাকে।",
  "saveError": "আমরা এই ব্রাউজারে আপনার কুকি পছন্দগুলি সংরক্ষণ করতে পারিনি৷ আপনার স্টোরেজ বা গোপনীয়তা সেটিংস চেক করুন এবং আবার চেষ্টা করুন।",
  "accept": "সব স্বীকার করুন",
  "reject": "প্রত্যাখ্যান ঐচ্ছিক",
  "learnMore": "গোপনীয়তা বিজ্ঞপ্তি"
};

export const NOT_FOUND_PAGE_COPY_BN = {
  "title": "404 | Stocktag",
  "description": "আপনি যে পৃষ্ঠাটি খুঁজছেন তা খুঁজে পাওয়া যায়নি।",
  "ariaLabel": "পেজ পাওয়া যায়নি",
  "goHome": "বাড়ি যান",
  "openStudio": "Metadata Studio খুলুন"
};

export const MOBILE_NAV_LABELS_BN = {
  "menu": "মেনু",
  "metadata": "মেটাডেটা",
  "studio": "স্টুডিও",
  "history": "ইতিহাস",
  "market": "বাজার",
  "profile": "প্রোফাইল",
  "login": "লগইন করুন",
  "navAriaLabel": "মোবাইল নেভিগেশন"
};

export const HELP_CENTER_COPY_BN = {
  "onThisPageTitle": "এই পৃষ্ঠায়",
  "onThisPageBody": "সহায়তা পৃষ্ঠাটি এখন প্রকৃত পণ্যের যাত্রা অনুসরণ করে: সেটআপ, আপলোড, নিয়ম সেটিং, পর্যালোচনা, রপ্তানি এবং ইতিহাস।",
  "overviewTitle": "প্রথমবার ব্যবহারকারীর জন্য সঠিক অর্ডার",
  "overviewBody": "প্রথমে অ্যাকাউন্ট এবং ক্রেডিট সেটআপ পরিষ্কার করুন, তারপর ফাইলগুলি আনুন, নিয়মগুলি সংজ্ঞায়িত করুন, ফলাফল পরিমার্জন করুন এবং শেষে রপ্তানি করুন৷",
  "overviewCards": [
    {
      "id": "prepare",
      "title": "প্রস্তুত করুন",
      "body": "পরিকল্পনা, ক্রেডিট এবং BYOK কৌশল নিশ্চিত করুন।"
    },
    {
      "id": "produce",
      "title": "উৎপাদন",
      "body": "সম্পদ আপলোড করুন, মেটাডেটা নিয়মগুলি সংজ্ঞায়িত করুন এবং আউটপুট শক্ত করুন।"
    },
    {
      "id": "deliver",
      "title": "ডেলিভারি",
      "body": "বাজারের জন্য রপ্তানি করুন, ইতিহাস থেকে পুনরায় ডাউনলোড করুন এবং খসড়া পুনরুদ্ধার করুন।"
    }
  ],
  "flowTitle": "ধাপে ধাপে কর্মপ্রবাহ",
  "flowBody": "প্রতিটি বিভাগে আপনি যে স্ক্রীন ব্যবহার করেন এবং সেই পর্যায়ে আপনি যে পদক্ষেপ নিতে পারেন তা উভয়ই দেখায়।",
  "extraToolsTitle": "প্রধান প্রবাহের বাইরে সহায়ক সরঞ্জাম",
  "extraToolsBody": "এইগুলি হল অতিরিক্ত মডিউলগুলি যা আপনি মূল মেটাডেটা কর্মপ্রবাহের পরে ব্যবহার করেন।",
  "resultLabel": "এই পর্যায়ের ফলাফল",
  "mediaLabel": "স্ক্রীন আপনি এখানে দেখতে পাবেন",
  "stageSetupLabel": "সেটআপ",
  "stageSetupTitle": "আপনার কর্মক্ষেত্র প্রস্তুত করুন",
  "stageSetupSummary": "প্রথম সেশনের আগে অ্যাকাউন্টের অবস্থা এবং ব্যবহারযোগ্য ক্রেডিট নিশ্চিত করুন।",
  "stageSetupResult": "আপনি কোন ক্রেডিট প্ল্যান ও ব্যালেন্স নিয়ে কাজ করছেন তা জানবেন।",
  "stageUploadLabel": "আপলোড করুন",
  "stageUploadTitle": "স্টুডিওতে ফাইল আনুন",
  "stageUploadSummary": "ইমেজ, ভেক্টর, এবং ভিডিও আমদানি করুন এবং কাজের সেশন শুরু করুন।",
  "stageUploadResult": "আপনার সেশন প্রস্তুত এবং সম্পদগুলি একটি পরিষ্কার প্রক্রিয়াকরণ প্রবাহে প্রবেশ করে৷",
  "stageRulesLabel": "নিয়ন্ত্রণ",
  "stageRulesTitle": "মেটাডেটা নিয়ম সংজ্ঞায়িত করুন",
  "stageRulesSummary": "প্রজন্মের আগে শিরোনাম, বর্ণনা, কীওয়ার্ড, ভাষা এবং সম্পদ আচরণের আকার দিন।",
  "stageRulesResult": "আউটপুট জেনেরিক হওয়া বন্ধ করে এবং আপনার নিজস্ব মানের মানের সাথে মেলে।",
  "stageReviewLabel": "পরিমার্জন",
  "stageReviewTitle": "পর্যালোচনা এবং আঁট ফলাফল",
  "stageReviewSummary": "ডেলিভারির আগে জেনারেট করা মেটাডেটা এডিট, রিজেনারেট এবং পরিষ্কার করুন।",
  "stageReviewResult": "আপনি পরিচ্ছন্ন, আরও প্রাসঙ্গিক, এবং আরও প্রতিরক্ষাযোগ্য মার্কেটপ্লেস মেটাডেটা দিয়ে শেষ করবেন।",
  "stageExportLabel": "ডেলিভারি",
  "stageExportTitle": "বাজারের জন্য রপ্তানি",
  "stageExportSummary": "ফরম্যাট বেছে নিন, প্রিসেট প্রয়োগ করুন এবং এক সেশন থেকে একাধিক আউটপুট তৈরি করুন।",
  "stageExportResult": "আপনি প্রতিটি প্ল্যাটফর্মের জন্য প্রস্তুত CSV ফাইল বা এমবেডেড মেটাডেটা প্যাকেজ নিয়ে চলে যান।",
  "stageHistoryLabel": "সংরক্ষণাগার",
  "stageHistoryTitle": "ইতিহাসে ফিরে যান এবং খসড়া পুনরুদ্ধার করুন",
  "stageHistorySummary": "পুরানো রপ্তানি আবার ডাউনলোড করুন, খসড়া পুনরুদ্ধার করুন এবং সংরক্ষণাগারটি পরিষ্কার রাখুন৷",
  "stageHistoryResult": "আগের কাজ সেশনের মধ্যে হারিয়ে যাওয়ার পরিবর্তে পুনরায় ব্যবহারযোগ্য থাকে।",
  "supportedFilesTitle": "সমর্থিত ফাইল",
  "supportedFilesBody": "JPG, PNG, SVG, EPS, MP4, এবং MOV সব একই স্টুডিওতে পরিচালনা করা যেতে পারে।",
  "rulesGuardrailsTitle": "নিয়ম এবং guardrails",
  "rulesGuardrailsBody": "AI আউটপুট নিরাপদ সীমানার মধ্যে রাখতে কাস্টম নির্দেশাবলী এবং নিষিদ্ধ শব্দ ব্যবহার করুন।",
  "rulesAdvancedTitle": "ভাষা, মোড এবং এআই গভীরতা",
  "rulesAdvancedBody": "অনুবাদ, PNG/ভেক্টর/EPS মোড, এবং গভীর বিশ্লেষণ সেটিংস আপনাকে বিভিন্ন সম্পদের প্রকারের জন্য আচরণ সামঞ্জস্য করতে দেয়।",
  "aiRefineTitle": "এআই পরিশোধন",
  "aiRefineBody": "যুক্তি, পুনর্জন্ম এবং গভীর বিশ্লেষণ আপনাকে দুর্বল আউটপুটকে দ্রুত শক্তিশালী করতে সহায়তা করে।",
  "presetCardTitle": "পূর্বনির্ধারিত যুক্তি",
  "presetCardBody": "একই মেটাডেটা সেট বিভিন্ন মার্কেটপ্লেস প্রত্যাশার জন্য পুনরায় আকার দেওয়া যেতে পারে।",
  "extraToolsNavLabel": "অতিরিক্ত সরঞ্জাম"
};

export const SUPPORT_COPY_BN = {
  "helpEyebrow": "সাপোর্ট হাব",
  "helpTitle": "একটি উত্তর দ্রুততম রুট চয়ন করুন",
  "helpBody": "দ্রুত নির্দেশনার জন্য সহকারী ব্যবহার করুন, ব্যক্তিগত বা অ্যাকাউন্ট-নির্দিষ্ট সাহায্যের জন্য একজন প্রকৃত ব্যক্তিকে ইমেল করুন এবং পণ্যের ধারণাগুলি প্রতিক্রিয়া বোর্ডে দৃশ্যমান রাখুন।",
  "feedbackEyebrow": "ডান চ্যানেল, দ্রুত প্রতিক্রিয়া",
  "feedbackTitle": "প্রতিক্রিয়া এবং সমর্থন বিভিন্ন কাজ আছে",
  "feedbackBody": "পণ্যের ধারণাগুলি সর্বজনীনভাবে পোস্ট করুন যাতে অন্যরা যোগদান করতে পারে৷ ব্যক্তিগত, বিলিং, অ্যাকাউন্ট বা ব্লকিং সমস্যাগুলি সরাসরি সহায়তা টিমের কাছে পাঠান৷",
  "aiTitle": "এআই সহকারীকে জিজ্ঞাসা করুন",
  "aiBody": "কর্মপ্রবাহ, সেটিংস, রপ্তানি এবং ক্রেডিট সম্পর্কে একটি তাত্ক্ষণিক উত্তর পান।",
  "aiAction": "সহকারী খুলুন",
  "humanTitle": "একজন প্রকৃত ব্যক্তির সাথে কথা বলুন",
  "humanBody": "অ্যাকাউন্ট, বিলিং, নিরাপত্তা, ব্যক্তিগত বা অমীমাংসিত সমস্যার জন্য ইমেল ব্যবহার করুন।",
  "humanAction": "মানব সমর্থন ইমেল করুন",
  "feedbackCardTitle": "একটি পণ্য ধারণা শেয়ার করুন",
  "feedbackBodyCard": "একটি সর্বজনীন অনুরোধ শুরু করুন, এর স্থিতি অনুসরণ করুন এবং আলোচনা চালিয়ে যান।",
  "feedbackAction": "ফিডব্যাক বোর্ড খুলুন",
  "helpCardTitle": "সহায়তা কেন্দ্র পড়ুন",
  "helpCardBody": "একটি অনুরোধ খোলার আগে নির্দেশিত কর্মপ্রবাহ এবং সাধারণ উত্তরগুলি পরীক্ষা করুন৷",
  "helpCardAction": "সহায়তা কেন্দ্র খুলুন",
  "privacyNote": "ফিডব্যাক বোর্ড সর্বজনীন। API কী, অর্থপ্রদানের বিশদ বিবরণ, ব্যক্তিগত ডেটা বা ব্যক্তিগত অ্যাকাউন্টের তথ্য কখনই পোস্ট করবেন না।",
  "launcherLabel": "সমর্থন",
  "chatbotTitle": "Stocktag সমর্থন",
  "chatbotStatus": "এআই সহকারী · মানুষের সাহায্য উপলব্ধ",
  "chatbotHumanStatus": "সমর্থন দল এই কথোপকথন পরিচালনা করছে",
  "chatbotHumanQueuedNotice": "নতুন বার্তাগুলি সমর্থন সারিতে সংরক্ষিত হয়৷ দলের উত্তর এখানে প্রদর্শিত হবে.",
  "chatbotAdminSender": "সমর্থন দল",
  "chatbotAiSender": "এআই সহকারী",
  "humanPromptTitle": "একজন প্রকৃত মানুষ প্রয়োজন?",
  "humanPromptBody": "Stocktag টিমকে ইমেল করুন এবং আপনার খসড়াতে বর্তমান চ্যাট প্রসঙ্গ অন্তর্ভুক্ত করুন৷",
  "chatbotHumanAction": "ইমেল সমর্থন",
  "chatbotFeedbackAction": "মতামত শেয়ার করুন",
  "chatbotHelpAction": "সহায়তা কেন্দ্র",
  "chatbotFooterNote": "চ্যাট অনুমোদিত সহায়তা কর্মীদের কাছে দৃশ্যমান, যারা প্রয়োজনে এখানে উত্তর দিতে পারে।",
  "chatbotPrivacyNotice": "চ্যাট বার্তাগুলি Stocktag সার্ভারে সংরক্ষণ করা হয় এবং অনুমোদিত সহায়তা কর্মীদের দ্বারা পর্যালোচনা এবং উত্তর দেওয়া হতে পারে৷ পাসওয়ার্ড, API কী, কার্ডের বিশদ বিবরণ বা সংবেদনশীল ব্যক্তিগত ডেটা শেয়ার করবেন না।",
  "chatbotPrivacyAction": "গোপনীয়তা",
  "chatbotSources": "সম্পর্কিত যাচাইকৃত উত্তর",
  "chatbotResolvedPrompt": "এই সমস্যা সমাধান?",
  "chatbotResolvedYes": "হ্যাঁ, সমাধান করা হয়েছে",
  "chatbotResolvedNo": "না, নির্ণয় চালিয়ে যান",
  "chatbotResolvedThanks": "ধন্যবাদ — রেজোলিউশন উল্লেখ করা হয়েছে.",
  "chatbotContinuing": "পরবর্তী ডায়গনিস্টিক ধাপের সাথে অবিরত...",
  "chatPromptHelp": "আমার প্রশ্নের জন্য সঠিক Stocktag ওয়ার্কফ্লো বেছে নিতে সাহায্য করুন।",
  "chatPromptFeedback": "আমাকে আমার পণ্য ধারণা পরিষ্কার, দরকারী প্রতিক্রিয়া পরিণত করতে সাহায্য করুন.",
  "emailSubject": "Stocktag সমর্থন অনুরোধ",
  "emailIntro": "আমি Stocktag সমর্থন দলের কাছ থেকে সাহায্য চাই।",
  "emailSummary": "নীচের অনুরোধের সাথে আমাকে সাহায্য করুন.",
  "escalationSubject": "Stocktag সমর্থন - চ্যাট বৃদ্ধি",
  "escalationIntro": "আমি Stocktag AI সহকারী দিয়ে শুরু করেছি এবং এখন একজন প্রকৃত ব্যক্তির সাহায্য চাই।",
  "escalationSummary": "এই সমর্থন অনুরোধ চালিয়ে যান.",
  "bugNoticeTitle": "এই ব্লকিং কাজ নাকি আপনার অ্যাকাউন্টের সাথে সম্পর্কিত?",
  "bugNoticeBody": "জরুরী, ব্যক্তিগত, বিলিং বা অ্যাকাউন্ট সমস্যাগুলির জন্য, ইমেল সমর্থনও। সংবেদনশীল বিবরণ সর্বজনীনভাবে পোস্ট করবেন না।",
  "bugNoticeAction": "মানব সমর্থন ইমেল করুন",
  "socialTitle": "অফিসিয়াল Stocktag সামাজিক পৃষ্ঠা",
  "socialBody": "ঘোষণা এবং জনসাধারণের যোগাযোগের জন্য এই পৃষ্ঠাগুলি ব্যবহার করুন। পরিবর্তে ইমেলের মাধ্যমে ব্যক্তিগত অ্যাকাউন্ট, বিলিং, নিরাপত্তা বা অর্থপ্রদানের প্রসঙ্গ পাঠান।"
};


export default HELP_CENTER_COPY_BN;
